import { TProjectConfigurationParameter } from 'pages/common/types';
import { LayingType } from 'pages/common/components/LayingTypeField/const';
import { TInputs } from '../forms/dimensions/types';

export const getDefaultParams = (
  projectConfigurationParameters: Array<TProjectConfigurationParameter> | undefined
): TInputs => {
  let params: { [key: string]: string | null } = {
    width: '0',
    length: '0',
    layingType: LayingType.horizontal,
    area: '0',
  };
  if (!projectConfigurationParameters) {
    return params as TInputs;
  }

  projectConfigurationParameters.forEach(({ key, value }) => {
    if (Object.keys(params).includes(key)) {
      params[key] = value;
    }
  });

  return params as TInputs;
};
